import React from 'react'
import IndividualMain from '../Components/individual/IndividualMain'


function IndividualPage() {
  return (
    <div>
        <IndividualMain></IndividualMain>
    </div>
  )
}

export default IndividualPage